import { render, staticRenderFns } from "./touristComplainIncresRate.vue?vue&type=template&id=107ce91a&scoped=true"
import script from "./touristComplainIncresRate.vue?vue&type=script&lang=js"
export * from "./touristComplainIncresRate.vue?vue&type=script&lang=js"
import style0 from "./touristComplainIncresRate.vue?vue&type=style&index=0&id=107ce91a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ce91a",
  null
  
)

export default component.exports